__webpack_require__.p = "https://staticfiles.nb-sandbox.com/rightnow-website-prod/_next/";